<template>
    <b-modal ref="modal" centered :visible="boxUid !=null" @hidden="onModalHidden" class="tabbed">
        <template slot="modal-header">
            <h1>{{ Translations.sections.boxes.removal.title }}<span v-if="boxData"> - {{boxData.name}}</span></h1>
        </template>
        <template>
            <WaitingBlock v-if="viewState.isLoadingBox">
            </WaitingBlock>
            <b-form class="form" v-else>
                <template v-if="!isRemovable">
                    <h4>
                        Box not removable :
                    </h4>
                    <div class="removal-warning-card" v-if="((boxData||{}).statistics||{}).clockCount > 0">
                        <i :class="['fas', 'fa-exclamation-circle']"></i>
                        {{ boxData.statistics.clockCount }} linked clocks
                    </div>
                    <div class="removal-warning-card" v-if="((boxData||{}).statistics||{}).dayTemplateCount > 0">
                        <i :class="['fas', 'fa-exclamation-circle']"></i>
                        {{ boxData.statistics.dayTemplateCount }} linked day templates
                    </div>
                </template>
                <div v-else>
                    <h2 class="modal-content-title">{{Translations.sections.boxes.removal.text}}</h2>
                </div>
            </b-form>
        </template>
        <template slot="modal-footer">
            <Button :empty="true" class="close-popup" @click.prevent="cancelModal">{{ Translations.buttons.cancel }}</Button>
            <Button :empty="false" class="validate" v-if="!viewState.isLoadingBox && isRemovable" @click.prevent="deleteBox">{{ Translations.buttons.doDeleteBox }} </Button>
            <Button :empty="false" class="validate" v-else="!isRemovable" @click.prevent="hide()">{{ Translations.buttons.close }} </Button>
        </template>
    </b-modal>
</template>

<script>
    import Button from'@/components/common/Button';
    import Bootstrap from 'bootstrap-vue';
    import store from '@/store';
    import router from '@/router';
    import Translations from '@/store/translations';
    import EventBus from '@/eventbus';
    import Portlet from '@/components/common/Portlet.vue';
    import { HTTP } from "@/utils/http";
    import { mapState } from 'vuex';
    import WaitingBlock from'@/components/common/WaitingBlock'
    import Apis from '@/apis/index';
    export default {
        name: "BoxRemovalCard",
        store,
        components: { Portlet, Bootstrap, Button, WaitingBlock },
        computed: {
            ...mapState(['currentStation', 'editedBox']),
            Translations: function () { return Translations; },
            errorMessages: function (inputName) {
                if (this.creationResponse == null || this.creationResponse.errors == null) return [];
            },
            isRemovable() {
                return !this.viewState.hasLoadingError
                    && this.boxData != null
                    && this.boxData.statistics != null
                    && this.boxData.statistics.dayTemplateCount == 0
                    && this.boxData.statistics.clockCount == 0;
            },
        },
        props: {
            boxUid: { required: true }
        },
        mounted() {
            this.loadStatistics();
        },
        watch: {
            currentStation: function () { console.log('station loaded'); },
            boxUid: function () {
                this.loadStatistics();
            }
        },
        data() {
            return {
                viewState: {
                    show: true,
                    visible: true,
                    isLoadingBox: true,
                    hasLoadingError: false
                },
                boxData: null,
                creationResponse: null,
                error: null
            }
        },
        methods: {
            show() {
                this.resetData();
                this.$refs.modal.show();
            },
            hide() {
                this.resetData();
                this.$refs.modal.hide();
            },
            resetData() {
                this.error = null;
                this.viewState.isLoadingClock = true;
                this.viewState.isDeletingClock = this.viewState.hasDeleteError = this.viewState.hasLoadingError = false;
                this.deleteResponse = this.clockData = null;
            },
            loadStatistics() {
                try {
                    if (this.currentStation != null && this.boxUid != null) {
                        this.viewState.isLoadingBox = true;
                        HTTP.post(Apis.boxes.removalData, { stationUid: this.$route.params.stationUid, boxUid: this.boxUid })
                            .then(this.onBoxLoaded, this.onBoxLoadError)
                            .then(this.onBoxLoadComplete);
                    }
                    else {
                    }
                } catch (e) {
                    console.log(e);
                    alert(e);
                }
            },
            onBoxLoaded(response) {
                this.boxData = response.data.dataItem;
            },
            onBoxLoadError(response) { this.boxData = null; this.viewState.hasLoadingError },
            onBoxLoadComplete(response) { this.viewState.isLoadingBox = false; },
            deleteBox() {
                // console.log("Delete Box");
                HTTP.post(Apis.boxes.remove, {
                    stationUid: this.currentStation.uid,
                    boxUid: this.boxUid
                })
                    .then(this.onBoxDeleted, this.onBoxDeleteError);
            },
            onBoxDeleted(response) {
                this.creationResponse = response;
                if (this.creationResponse.status === 200) {
                    var editedBoxResponse = this.creationResponse.data;
                    if (editedBoxResponse != null) {
                        store.dispatch('loadStationBoxes', this.$route.params.stationUid);
                        this.cancelModal();
                        this.viewState.isRemoving = false;
                        EventBus.$emit('onBoxDeleted', this.boxUid);
                    }
                    this.cancelModal();
                } else {
                    //let vue build the error messages
                }
            },
            onBoxDeleteError(response) {
                this.creationResponse = response;
            },
            cancelModal() { this.$refs['modal'].hide() },
            onModalHidden() { EventBus.$emit('onBoxRemovalEnded'); }
        }
    }
</script>

<style>
</style>
